import React from 'react';
import { Plus, Trash2 } from 'lucide-react';

// Dynamic list builder for a facilitator's bookable private-session options.
// Each option: { id?, name, duration_min, price (0 = free), description }.
const SessionTypesEditor = ({ value = [], onChange, currency = 'usd' }) => {
  const rows = value || [];
  const update = (i, k, v) => onChange(rows.map((r, idx) => (idx === i ? { ...r, [k]: v } : r)));
  const add = () => onChange([...rows, { name: '', duration_min: '', price: '', description: '' }]);
  const remove = (i) => onChange(rows.filter((_, idx) => idx !== i));

  return (
    <div className="space-y-3" data-testid="session-types-editor">
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-widest text-mahogany/70">Session options</span>
        <button type="button" onClick={add} className="pill-btn-outline text-xs py-1" data-testid="add-session-type">
          <Plus className="w-3.5 h-3.5" /> Add option
        </button>
      </div>
      {rows.length === 0 && <p className="text-xs text-mahogany/60">Add at least one option, e.g. "15 minute guidance". Leave price 0 for a free session.</p>}
      {rows.map((r, i) => (
        <div key={i} className="rounded-2xl bg-white border border-rose/30 p-3 space-y-2" data-testid={`session-type-row-${i}`}>
          <div className="flex items-start gap-2">
            <input value={r.name || ''} onChange={(e) => update(i, 'name', e.target.value)} placeholder="Option name (e.g. 15 minute guidance)"
              className="flex-1 bg-cream/50 rounded-lg px-3 py-2 border border-rose/50 text-sm" data-testid={`session-type-name-${i}`} />
            <button type="button" onClick={() => remove(i)} className="text-red-500/80 hover:text-red-600 p-2" data-testid={`session-type-remove-${i}`}><Trash2 className="w-4 h-4" /></button>
          </div>
          <div className="grid sm:grid-cols-2 gap-2">
            <label className="text-[11px] uppercase tracking-widest text-mahogany/60">Duration (min)
              <input type="number" min="0" value={r.duration_min ?? ''} onChange={(e) => update(i, 'duration_min', e.target.value)}
                className="mt-1 w-full bg-cream/50 rounded-lg px-3 py-2 border border-rose/50 text-sm" data-testid={`session-type-duration-${i}`} />
            </label>
            <label className="text-[11px] uppercase tracking-widest text-mahogany/60">Price ({(currency || 'usd').toUpperCase()}) — 0 = free
              <input type="number" step="0.01" min="0" value={r.price ?? ''} onChange={(e) => update(i, 'price', e.target.value)}
                className="mt-1 w-full bg-cream/50 rounded-lg px-3 py-2 border border-rose/50 text-sm" data-testid={`session-type-price-${i}`} />
            </label>
          </div>
          <input value={r.description || ''} onChange={(e) => update(i, 'description', e.target.value)} placeholder="Short description (optional)"
            className="w-full bg-cream/50 rounded-lg px-3 py-2 border border-rose/50 text-sm" data-testid={`session-type-desc-${i}`} />
        </div>
      ))}
    </div>
  );
};

export default SessionTypesEditor;
